module.exports = __webpack_public_path__ + "static/media/formCloseWhite.a40f6b00.svg";